import { Box, Button, Flex, FormControl, Heading, Input, Stack } from "@chakra-ui/react"
import { ErrorMessage, Form, Formik } from "formik"
import { FC } from "react"
import { ILoginFormFields } from "."
import { FormikOnSubmit } from "../../../../utils/types"
import { ThePatidarsLogo } from "../../../shared/ThePatidarsLogo"
import { ErrorMessageField } from "../../../ui"
import { InputLabel } from "../../../ui/InputLabel"

interface Props {
	handleSubmit: FormikOnSubmit<ILoginFormFields>
}

const gradiantStartColor = "#002A64"
const gradiantEndColor = "#006CEF"

export const LoginFormView: FC<Props> = ({ handleSubmit }) => (
	<Box
		padding={20}
		borderWidth={1}
		borderRadius={15}
		backgroundColor="white"
		boxShadow="1px 1px 30px #eee"
	>
		<Formik<ILoginFormFields>
			initialValues={{
				mobile: { countryCode: "91", mobileNo: "" },
				password: "",
				deviceId: "reviewer",
			}}
			onSubmit={handleSubmit}
			enableReinitialize
		>
			{({ handleChange, isSubmitting }) => (
				<Stack as={Form} maxWidth={"sm"}>
					<Box textAlign={"center"}>
						<ThePatidarsLogo />
						<Heading
							as="h2"
							width={"fit-content"}
							bgGradient={`linear(to-br, ${gradiantStartColor}, ${gradiantEndColor})`}
							bgClip="text"
							fontWeight={"bold"}
							lineHeight={"shorter"}
							fontSize={"2xl"}
							margin={"auto"}
							mb={"4"}
						>
							Reviewer Portal
						</Heading>
					</Box>
					<Flex direction={"column"} gridGap={"2"}>
						{/* Mobile No. */}
						<FormControl>
							<InputLabel label="Mobile No." />
							<Input
								name="mobile.mobileNo"
								onChange={handleChange}
								isRequired
								autoFocus
								type={"number"}
								maxLength={10}
							/>
							<ErrorMessage
								component={ErrorMessageField}
								name="mobile.mobileNo"
							/>
						</FormControl>
						{/* Password */}
						<FormControl>
							<InputLabel label="Password" />
							<Input
								type="password"
								name="password"
								isRequired
								onChange={handleChange}
							/>
							<ErrorMessage component={ErrorMessageField} name="password" />
						</FormControl>
					</Flex>
					<Box py="2">
						{/* Login Button */}
						<Button
							colorScheme={"blue"}
							type="submit"
							disabled={isSubmitting}
							isLoading={isSubmitting}
							width={"full"}
						>
							Login
						</Button>
					</Box>
				</Stack>
			)}
		</Formik>
	</Box>
)
